/* FESTI MARKET — confirmation Samita : collections et fiches produit.
   Grille : popup Samita conservé.
   Fiche produit : produit ajouté au devis sans redirection ni popup de confirmation.
   Le script ne soumet jamais le devis et ne réalise aucun ajout : Samita reste le moteur. */
(function () {
  'use strict';

  var path = window.location.pathname;
  var isCollectionGrid = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^/]+\/?$/i.test(path);
  var isProductPage = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:products\/[^/]+|collections\/[^/]+\/products\/[^/]+)\/?$/i.test(path);
  if (!isCollectionGrid && !isProductPage) return;

  var SELECTOR = isCollectionGrid
    ? '.rfq-collection-btn, [id^="rfq-collection-btn-"]'
    : '.rfq-btn, [id^="rfq-btn-"]';
  var KEYS = ['settings', 'config', 'configs', 'quote', 'quoteSettings'];
  var MAX_TRIES = 80;
  var tries = 0;
  var poll = null;
  var observer = null;
  var observerTimer = null;

  function applyNativeConfirmation() {
    var root = window.GRFQConfigs;
    if (!root || typeof root !== 'object') return false;

    var found = false;
    var visited = [];
    function visit(obj, depth) {
      if (!obj || typeof obj !== 'object' || depth > 3 || visited.indexOf(obj) !== -1) return;
      visited.push(obj);

      // Mode deja valide sur les grilles : ajout au devis sans redirection.
      // Le popup qui accompagne ce mode est supprime uniquement sur fiche produit.
      if (Object.prototype.hasOwnProperty.call(obj, 'message_type') &&
          typeof obj.message_type === 'string') {
        obj.message_type = 'popupcontinue';
        found = true;
      }
      if (Object.prototype.hasOwnProperty.call(obj, 'message_type_afteratq') &&
          typeof obj.message_type_afteratq === 'string') {
        obj.message_type_afteratq = 'popup';
        found = true;
      }

      // Les traductions du popup ne sont modifiees que sur les grilles.
      if (isCollectionGrid) {
        [obj, obj.translation_default].forEach(function (source) {
          if (!source || typeof source !== 'object') return;
          if (typeof source.popupcontinue === 'string') source.popupcontinue = 'Continuer les achats';
          if (typeof source.popupviewquote === 'string') source.popupviewquote = 'Voir mon devis';
        });
      }

      KEYS.forEach(function (key) { visit(obj[key], depth + 1); });
    }
    visit(root, 0);
    return found;
  }

  function stop() {
    if (poll !== null) { clearInterval(poll); poll = null; }
  }

  function attempt() {
    tries += 1;
    var found = applyNativeConfirmation();
    if (found || tries >= MAX_TRIES) stop();
    return found;
  }

  function norm(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function hasBothQuoteActions(node) {
    if (!node || node.nodeType !== 1 || !node.querySelectorAll) return false;
    var controls = node.querySelectorAll('a, button, [role="button"]');
    var continueFound = false, viewFound = false;
    for (var i = 0; i < controls.length; i++) {
      var label = norm(controls[i].textContent);
      if (/^(?:continuer|continuez|poursuivre|poursuivez).{0,22}achat|continue shopping/.test(label)) continueFound = true;
      if (/(?:voir|aller|acceder).{0,20}devis|(?:view|see).{0,20}quote/.test(label)) viewFound = true;
      if (continueFound && viewFound) return true;
    }
    return false;
  }

  function popupRoot(node) {
    if (!hasBothQuoteActions(node)) return null;
    var current = node, named = null, fixed = null, depth = 0;
    while (current && current !== document.body && depth++ < 11) {
      var identity = String(current.className || '') + ' ' + String(current.id || '');
      if (/(?:grfq|rfq|swal2|popup|modal|dialog|overlay)/i.test(identity) ||
          current.tagName === 'DIALOG' || current.getAttribute('role') === 'dialog' ||
          current.getAttribute('aria-modal') === 'true') named = current;
      try {
        if (window.getComputedStyle && window.getComputedStyle(current).position === 'fixed') fixed = current;
      } catch (error) { /* Rester dans le cadre de la confirmation. */ }
      current = current.parentElement;
    }
    return fixed || named || (node.parentElement !== document.body ? node : null);
  }

  function stopGuard() {
    if (observer) { observer.disconnect(); observer = null; }
    if (observerTimer !== null) { clearTimeout(observerTimer); observerTimer = null; }
  }

  function closeConfirmation(root, before) {
    if (!root || root === document.body) return;
    if (/swal2/i.test(String(root.className || '')) &&
        window.Swal && typeof window.Swal.close === 'function') {
      window.Swal.close();
    } else {
      var close = root.querySelector(
        '[data-dismiss="modal"], [data-bs-dismiss="modal"], .swal2-close, ' +
        '[class*="popup-close"], [class*="modal-close"], ' +
        'button[aria-label*="close" i], button[aria-label*="fermer" i], button[class*="close" i]'
      );
      if (close) close.click();
      else if (root.tagName === 'DIALOG' && typeof root.close === 'function') root.close();
      else if (root.parentElement) root.remove();
    }
    if (document.body && document.body.style && before) {
      // Restaurer uniquement une eventuelle modification du verrouillage de defilement.
      if (document.body.style.overflow === 'hidden') document.body.style.overflow = before.overflow;
    }
  }

  function beginPdpGuard() {
    if (!isProductPage || typeof MutationObserver !== 'function' || !document.body) return;
    stopGuard();
    var before = { overflow: document.body.style ? document.body.style.overflow : '' };
    observer = new MutationObserver(function (changes) {
      for (var i = 0; i < changes.length; i++) {
        var nodes = changes[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var candidate = nodes[j];
          var root = popupRoot(candidate);
          if (!root) continue;
          stopGuard();
          closeConfirmation(root, before);
          return;
        }
      }
    });
    observer.observe(document.body, {childList:true,subtree:true});
    observerTimer = setTimeout(stopGuard, 12000);
  }

  // Choisir le mode de collecte des produits avant le clic.
  if (!attempt()) poll = setInterval(attempt, 100);

  // Capture : application Samita laisse passer le clic et traite l'ajout normalement.
  document.addEventListener('click', function (event) {
    var el = event.target;
    if (!el || typeof el.closest !== 'function') return;
    var button = el.closest(SELECTOR);
    if (!button) return;

    applyNativeConfirmation();
    if (isProductPage) {
      // Certains themes utilisent un lien comme bouton devis :
      // neutraliser uniquement la navigation native, sans bloquer Samita.
      if (button.tagName === 'A' && /\/pages\/request-for-quote(?:[?#]|\/|$)/i.test(button.getAttribute('href') || '')) {
        event.preventDefault();
      }
      beginPdpGuard();
    }
  }, true);
})();
